import { atualUfDefinition } from "@/helpers/utils";
import { seloEvidenceReadScopeMixin } from "./seloEvidenceReadScope";

export default {
  mixins: [seloEvidenceReadScopeMixin],
  computed: {
    bancoConsultaSelo() {
      return atualUfDefinition.banco;
    },
  },
};
